import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck } from '@fortawesome/free-solid-svg-icons';
import { CarInDriverOrder } from '../../../../types/carAllocation';
import { format } from 'date-fns';
import { ja } from 'date-fns/locale';
import { formatTime } from '../../../../services/formatTime';
import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  formData: CarInDriverOrder;
};

const EditSideBarHeader: FC<Props> = ({ formData }) => {
  const getCategory = [
    {
      name: '回収',
      count: formData.carAllocations.filter((c) => c.workCategory.id === 1)
        .length,
      color: styles.blue,
    },
    {
      name: '保管',
      count: formData.carAllocations.filter((c) => c.workCategory.id === 4)
        .length,
      color: styles.lightBlue,
    },
    {
      name: '積込',
      count: formData.carAllocations.filter((c) => c.workCategory.id === 3)
        .length,
      color: styles.lightYellow,
    },
    {
      name: '処分',
      count: formData.carAllocations.filter((c) => c.workCategory.id === 2)
        .length,
      color: styles.yellow,
    },
  ];

  return (
    <div className={styles.head}>
      <div className={styles.aboveText}>
        <div className={styles.leftText}>
          <div className={styles.date}>
            {format(
              new Date(formData.carAllocations[0].workStartDate),
              'M/d(E)',
              {
                locale: ja,
              }
            )}
          </div>
          <div className={styles.time}>
            {formatTime(formData.carAllocations[0].workStartTime)}
          </div>
          <div className={styles.departureText}>出発</div>
        </div>
        <div className={styles.bottomText}>
          {getCategory.map((value) => {
            return (
              value.count !== 0 && (
                <div className={styles.contents} key={value.name}>
                  <div className={classNames(styles.label, value.color)} />
                  <div className={styles.collectText}>{value.name}</div>
                  <div className={styles.value}>{value.count}</div>
                  <div className={styles.itemText}>件</div>
                </div>
              )
            );
          })}
        </div>
      </div>
      <div className={styles.underText}>
        <FontAwesomeIcon icon={faTruck} className={styles.icon} />
        {formData.carCategory.name} / {formData.carNo}
      </div>
    </div>
  );
};

export default EditSideBarHeader;
